const initialState = {
  accepted_insurance_terms: 'v2',
  insured_for: undefined,
};

const initialStateForTest = {
  accepted_insurance_terms: 'v2',
  insured_for: undefined,
};

export default initialState;
export { initialStateForTest };
